import { render, staticRenderFns } from "./Error404.vue?vue&type=template&id=4ed9cd36&scoped=true"
import script from "./Error404.vue?vue&type=script&lang=js"
export * from "./Error404.vue?vue&type=script&lang=js"
import style0 from "./Error404.vue?vue&type=style&index=0&id=4ed9cd36&prod&scoped=true&lang=css"
import style1 from "./Error404.vue?vue&type=style&index=1&id=4ed9cd36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9cd36",
  null
  
)

export default component.exports